import {useEffect, useRef, useState} from 'react';

export const SHARE_ENDED_MS = 3_000;

export const useEndedShare = (sharerId: string | undefined): string | undefined => {
    const previous = useRef<string | undefined>(undefined);
    const [ended, setEnded] = useState<string | undefined>(undefined);

    useEffect(() => {
        const before = previous.current;
        previous.current = sharerId;
        if (sharerId) {
            setEnded(undefined);
        } else if (before) {
            setEnded(before);
        }
    }, [sharerId]);

    useEffect(() => {
        if (!ended) {
            return;
        }
        const timer = window.setTimeout(() => setEnded(undefined), SHARE_ENDED_MS);
        return () => window.clearTimeout(timer);
    }, [ended]);

    return ended;
};
